import Icon from '../components/Icon.vue'

Icon.register({"meh":{"width":496,"height":512,"paths":[{"d":"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM168 176C185.7 176 200 190.3 200 208S185.7 240 168 240 136 225.7 136 208 150.3 176 168 176zM344 368H152C143.2 368 136 360.8 136 352S143.2 336 152 336H344C352.8 336 360 343.2 360 352S352.8 368 344 368zM328 240C310.3 240 296 225.7 296 208S310.3 176 328 176 360 190.3 360 208 345.7 240 328 240z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/meh.js
// module id = zZC5
// module chunks = 0